import React from "react";
import infoIcon2 from "../../assets/images/svg/infoIcon2.svg";

const Tooltip = ({ msg }) => {
  return (
    <div className="tooltip-comp">
      <div className="img_wrapper">
        <img className="money_info" src={infoIcon2} alt="info" />
        <div className={`tool `}>
          <div className="irr_tip tip_align">
            <h2>{msg}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
